import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosIcon } from './icon'


@NgModule({
  declarations: [IcosIcon],
  exports: [IcosIcon],
  imports: [CommonModule],
  entryComponents: [IcosIcon],
})
export class IcosIconsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosIconsModule, providers: [] }
  }
}
